export default __webpack_public_path__ + "static/char-43-anr-5f7ab1bdd0924c9fb3dc56885c125741.gif";